import { render } from "./DistributeModal.vue?vue&type=template&id=0c548d2c&scoped=true&ts=true"
import script from "./DistributeModal.vue?vue&type=script&lang=ts"
export * from "./DistributeModal.vue?vue&type=script&lang=ts"

import "./DistributeModal.vue?vue&type=style&index=0&id=0c548d2c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c548d2c"]])

export default __exports__